<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_iv">To the boys and girls I knew at Washington School
            and to Susan and Tammy for the loan of some secrets</a></p><a id="page_iv">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?f784fd58